import React from 'react';

export interface NewsItem {
  date: string;
  subject: React.ReactNode;
  youTubeVideoId?: string;
  spotifySongId?: string;
}

export const newsItems: NewsItem[] = [
  {
    date: '7.4.2026',
    subject: (
      <>
        <span>{'Tuore singlemme Demoni on nyt ulkona! '}</span>
        <a
          href='https://push.fm/fl/kirke-demoni'
          target='_blank'
          rel='noopener noreferrer'
        >
          Kuuntele!
        </a>
      </>
    ),
    youTubeVideoId: 'ZJWRsb-Pk6c',
    spotifySongId: '2eWPaPhJ6C80fxy3eGF8SU',
  },
  {
    date: '23.1.2026',
    subject: (
      <>
        <span>{'Peto -video on nyt ulkona! Katso video alta tai '}</span>
        <a
          href='https://www.youtube.com/@Kirkeband'
          target='_blank'
          rel='noopener noreferrer'
        >
          YouTubesta
        </a>
        <span>{'.'}</span>
      </>
    ),
    youTubeVideoId: '7tIer9F0PcU',
  },
  {
    date: '9.1.2026',
    subject: (
      <>
        <span>{'Uusi singlemme Peto on julkaistu! Kuuntele '}</span>
        <a
          href='https://open.spotify.com/album/7niK1ymYgdxOEit02p9pYR?si=SyYMpOf1QQKaEfIXk3vGuA'
          target='_blank'
          rel='noopener noreferrer'
        >
          Spotifyssä
        </a>
        <span>{'.'}</span>
      </>
    ),
    spotifySongId: '4R9ZzuRNjUx4uC7HrGJkjU',
  },
];
